/* src/app/pages/casos/recibirresultados/recibirresultados.component.scss */
/*# sourceMappingURL=recibirresultados.component.css.map */
